import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { useState, useEffect } from "react";
import sendRequest2 from "hooks/useAxios2";
import { AiOutlineDelete } from "react-icons/ai";

import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
import ReactTooltip from "react-tooltip";

export default function Transaction({
  value,
  typeOfTransact,
  transferFrom,
  numberOfOrder,
  date,
  price,
  setUpdater
}) {
  const navigate = useNavigate();
  const deleteTransact = () => {
    Swal.fire({
      title: "آیا از حذف پست اطمینان دارید؟",
      // text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "حذف",
      cancelButtonText: "انصراف"
    }).then(result => {
      if (result.isConfirmed) {
        sendRequest2("delete_transactions", {
          muid: 4,
          transaction_id: value.id
        }).then(({ data }) => {
          if (data.status == 1) {
            Swal.fire("تراکنش با موفقیت حذف شد.");
            // navigate("/admin-panel/financial", { replace: true });
            setUpdater(prev => {
              return !prev;
            });
          } else {
            Swal.fire("مشکلی در حذف پست پیش آمده است.");
          }
        });
      }
    });
  };

  function showTime(x) {
    x = x * 1000;
    const date = new DateObject({ date: x, calendar: persian });
    return date.format();
  }
  return (
    <div className="transaction mt-5">
      <div className=" d-flex flex-row flex-wrap rounded-10 shadow mt-3 mx-4">
        <div className="item flex-grow-1">
          <div
            className="inner-item text-white bg-blue text-center px-4 py-3 "
            style={{ borderRadius: "0 10px 0 0" }}
          >
            نوع تراکنش
          </div>
          <div className="inner-item text-center px-4 py-3">
            {/* {typeOfTransact} */}
            {typeOfTransact == "1" ? "آنلاین" : "آفلاین"}
          </div>
        </div>

        <div className="item flex-grow-1">
          <div className="inner-item text-white bg-blue text-center px-4 py-3">
            نام کاربری
          </div>
          <div className="inner-item text-center px-4 py-3">{transferFrom}</div>
        </div>
        <div className=" item flex-grow-1">
          <div className="inner-item text-white bg-blue px-4 py-3 text-center ">
            شماره سفارش
          </div>
          <div className="inner-item text-center px-4 py-3">
            {numberOfOrder}
          </div>
        </div>

        <div className=" item flex-grow-1">
          <div className="inner-item text-white bg-blue px-4 py-3 text-center">
            تاریخ
          </div>
          <div className="inner-item text-center px-4 py-3">
            {/* {date} */}
            {showTime(date)}
          </div>
        </div>

        <div className="item flex-grow-1">
          <div className=" inner-item text-white bg-blue px-4 py-3 text-center border1100-1">
            مبلغ
          </div>
          <div className=" inner-item text-center px-4 py-3">
            {addCommas(+price)} تومان
          </div>
        </div>
        <div className="item flex-grow-1">
          <div
            className="inner-item text-white bg-blue px-4 py-3 text-center border1000-2"
            style={{ borderRadius: "10px 0 0 0" }}
          >
            عملیات
          </div>
          <div className="inner-item text-center px-4 py-3">
            <button
              className="btn text-danger my-0 py-0"
              data-tip="حذف تراکنش"
              onClick={deleteTransact}
            >
              <ReactTooltip />
              <AiOutlineDelete />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
